<div class="invoices-page">
  <ysh-table-set [dataSource]="dataSource">
  </ysh-table-set>
</div>
